export default "__VITE_ASSET__PIjo5O90__"